import styled from "styled-components";

export const InputDatePickerNewStyled = styled.div`
  position: relative;

  .picker_button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    padding: 9.6px 9px;
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    background: ${({ theme, disabled }) =>
      disabled ? theme.COLORS.GRAY_28 : theme.COLORS.WHITE_1};
    border: 1px solid ${({ theme }) => theme.COLORS.GRAY_10};
    border-radius: 8px;
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    text-align: left;
  }

  .picker_text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .placeholder_text {
    color: ${({ theme }) => theme.COLORS.GRAY_4};
  }

  .picker_icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    margin-left: 8px;
  }

  .theme_standard {
    .picker_button {
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      background: ${({ theme, disabled }) =>
        disabled ? theme.COLORS.GRAY_36 : theme.COLORS.WHITE_1};
    }
  }

  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__tab-loop {
    .react-datepicker-popper {
      z-index: 2;
      min-width: 230px;
    }
  }
`;
